export default __webpack_public_path__ + "static/media/insurance-stamp.413f7d65.png";